/* eslint-disable @next/next/no-img-element */

// components
import { Container } from 'components/Grid';
import { VideoPlayer } from '@/containers-m/VideoPlayer';

// styles
import {
  SectionWrapper,
  TitleWrapper,
  CTAWrapper,
  Title,
  IntroText,
  MediaWrapper,
  LogoWrapper,
  ContenWrapper,
} from './FreightSection.styles';
import { MirandaGradientButton } from '@/components/Button/BaseButton';

//logo
import FIAI from '@/public/images/logos/logo-freightintel-ai.svg';

export function FreightSection() {
  const video_settings = {
    youtube: 'https://www.youtube.com/watch?v=_rf7_1NE8-M?rel=0',
    thumb: '/images/home/freightintel/freightintelai-thumb.jpg',
    preview: '/videos/home/bg_fiai_promotion.webm',
  };

  return (
    <SectionWrapper>
      <Container>
        <TitleWrapper>
          <LogoWrapper>
            <FIAI width="418" height="48" />
          </LogoWrapper>

          <Title>Unlocking Insights with advanced machine learning</Title>
          <IntroText>
            FreightIntel AI analyzes complex data sets, identifies trends, and
            delivers customized recommendations based on patterns it uncovers.
          </IntroText>
        </TitleWrapper>
        <MediaWrapper>
          <VideoPlayer content={video_settings} />
        </MediaWrapper>
        <ContenWrapper>
          <p>
            FreightIntel AI functions as a seasoned transportation expert,
            capable of quickly grasping the intricacies of logistics without the
            need for additional input. Shippers simply connect their data and
            receive insightful, data-driven recommendations.
          </p>
          <p>
            The system combines a shipper’s logistics information with
            Loadsmart’s robust benchmarking dataset and state-of-the-art AI
            technology to create insights tailored to the unique needs of each
            business.
          </p>
        </ContenWrapper>
        <CTAWrapper>
          <MirandaGradientButton
            as="a"
            href="https://lp.loadsmart.com/freight-intel-ai?utm_source=loadsmart&utm_medium=cta&utm_campaign=fi-ai-midmarket-fintech-q3-24&utm_content=home-page"
            target="_blank"
          >
            <span>Learn More</span>
          </MirandaGradientButton>
        </CTAWrapper>
      </Container>
    </SectionWrapper>
  );
}
